module.exports = __webpack_public_path__ + "img/products_car.69266e7e.png";